import { HostMessage, HostMessageType, generators } from '@playcastdotio/Messaging';
import type { IMessageRouter } from '../../services/MessageRouter';
import type { IIpcService } from '../../services/ipc/IIpcService';

export type NonsoleExitCoordinatorDeps = {
  ipcService: IIpcService;
  getHostId: () => string;
};

/**
 * Handles operator-initiated Nonsole/guest-mode teardown delivered over the
 * realtime WebSocket (`HOST_EXIT_NONSOLE`). Bridges to PlaycastService via
 * the existing `cancelProvisioningScript` IPC with `exitGuestMode: true` and
 * no reboot.
 */
export class NonsoleExitCoordinator {
  constructor(private readonly deps: NonsoleExitCoordinatorDeps) {}

  public registerMessageHandlers(router: IMessageRouter): void {
    router.register(HostMessageType.HOST_EXIT_NONSOLE as any, this.onExitNonsole.bind(this) as any);
  }

  private onExitNonsole(message: HostMessage): void {
    if (message.type !== HostMessageType.HOST_EXIT_NONSOLE) return;

    const hostId = this.deps.getHostId();
    const ipcMessage = generators.system.cancelProvisioningScript(hostId, {
      exitGuestMode: true,
      rebootIfSafe: false,
    });
    this.deps.ipcService.send(ipcMessage);
  }
}
